"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var styled_components_1 = require("styled-components");
var Grid_1 = require("./Grid");
exports.default = styled_components_1.default(Grid_1.Flex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t> * {\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t&:not(:last-child):not(:first-child) {\n\t\t\tborder-radius: 0;\n\t\t}\n\n\t\t&:hover {\n\t\t\tz-index: 1;\n\t\t}\n\t}\n"], ["\n\t> * {\n\t\t&:first-child {\n\t\t\tborder-top-right-radius: 0;\n\t\t\tborder-bottom-right-radius: 0;\n\t\t}\n\n\t\t&:last-child {\n\t\t\tborder-top-left-radius: 0;\n\t\t\tborder-bottom-left-radius: 0;\n\t\t}\n\n\t\t&:not(:last-child):not(:first-child) {\n\t\t\tborder-radius: 0;\n\t\t}\n\n\t\t&:hover {\n\t\t\tz-index: 1;\n\t\t}\n\t}\n"])));
var templateObject_1;



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/dist/components/ButtonGroup.js
// module id = 618
// module chunks = 2